import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { IRootState } from "../../../../../../reducer/CombineReducer";
import { CreateScheduleSlice } from "../../../CreateSchedule/redux";
import YearlyDetailsView from "./YearlyConfig.view";

/**
 * Component will be rendered for reccurence type yearly. 
 * Responsible for rendering the yearly dropdown component
 */
const YearlyConfig = (): JSX.Element => {
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const dispatch = useDispatch();

  /**
   * In months of dropdown value onChange event 
   * Selected dropdown value will be updated in redux
   */
  const onFieldChange = (selectedValue: string): void => {
    const { schedulingDetails } = scheduling;
    const { recurrenceData } = schedulingDetails;
    const tempRecurrenceData = { ...recurrenceData,
      month: +selectedValue };
    dispatch(CreateScheduleSlice.actions.setNewScheduleDetails({
      ...scheduling.schedulingDetails,
      recurrenceData: tempRecurrenceData
    }));
  };

  return (
    <YearlyDetailsView onFieldChange={onFieldChange}/>
  );
};

export default YearlyConfig;
